import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const PurchaseOrderPage = lazy(
  () =>
    import("../../../../../components/WMS/PurchaseOrders/PurchaseOrderPage"),
)

export const Route = createFileRoute(
  "/_layout/WMS/documents/purchase-orders/$purchaseOrder",
)({
  validateSearch: (search: Record<string, unknown>) => ({
    tab:
      search.tab === "general"
        ? "general"
        : search.tab === "info"
          ? "info"
          : search.tab === "files"
            ? "files"
            : undefined,
    edit:
      search.edit === 1 || search.edit === "1" || search.edit === true
        ? 1
        : undefined,
  }),
  component: PurchaseOrderRoute,
})

function PurchaseOrderRoute() {
  return (
    <LazyRoutePage>
      <PurchaseOrderPage />
    </LazyRoutePage>
  )
}
